import React, { ReactNode } from 'react'
import { T } from '@transifex/react'

export type TCoreIoUserLanguageChoicesAll =
  | `EN`
  | `DA`
  | 'NO'
  | 'FI'
  | 'SV'
  | `EL`

export type TCoreIoUserLanguageChoices = `EN` | `DA` | 'NO' | 'FI' | 'SV'

export const coreIoUserLanguageChoicesLabelMap: Record<
  TCoreIoUserLanguageChoices,
  ReactNode
> = {
  DA: <T _str="Danish" />,
  EN: <T _str="English" />,
  FI: <T _str="Finnish" />,
  NO: <T _str="Norwegian" />,
  SV: <T _str="Swedish" />,
}
